import React, {Component, forwardRef} from 'react';
import {withRouter, Route} from 'react-router-dom';
import {connect} from 'react-redux';

// styles
import style from "../../Styles/Components/Input.module.css";

class Input extends Component {
    constructor() {
        super();
        this.state = {
            isValid: true
        }
    }

    render() {
        return (
            <div className={style.inputContainer}>
                <input className={style.input} value={this.props.value} onChange={(e) => {
                            this.props.onChange(e)
                        }}
                       name={this.props.name} placeholder={this.props.placeholder}/>
            </div>
        )
    }
}

export default React.forwardRef((props, ref) => <Input
    innerRef={ref} {...props}
/>);